import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlatList, Stack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import Paper from "../atoms/Paper";
import ListHeader from "../molecules/ListHeader";
import Headline from "../molecules/Headline";
import useResponsive from "../util/useResponsive";
import { useDevices } from "../providers/device";
import { DeviceItem } from "./DeviceItem";
import DeviceCard from "./DeviceCard";
const DeviceSection = () => {
    const { isSmallScreen } = useResponsive();
    const { devices } = useDevices();
    const { t } = useTranslation();
    if (!devices.length)
        return null;
    return isSmallScreen ? (_jsxs(Box, Object.assign({ px: {
            base: 4,
            md: 0,
        } }, { children: [_jsx(ListHeader, { title: t("usedDevices"), size: "xs", px: 0, borderBottomWidth: 0, bgColor: "none" }), _jsx(FlatList, { borderColor: "gray.100", bg: "amber.100", borderRadius: "lg", overflow: "hidden", showsVerticalScrollIndicator: false, scrollEventThrottle: 16, data: devices, renderItem: ({ item }) => _jsx(DeviceItem, { device: item }), keyExtractor: (item) => item.provider })] }))) : (_jsxs(Paper, { children: [_jsx(Headline, { title: t("usedDevices"), size: "xs", py: 6 }), _jsx(Stack, Object.assign({ direction: "row", px: 4, py: 2, width: "full", flexWrap: "wrap" }, { children: devices.map((item) => (_jsx(Box, Object.assign({ width: "1/3", p: 1 }, { children: _jsx(DeviceCard, { device: item }) }), item.provider))) }))] }));
};
export default DeviceSection;
